import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import { Button, InputBase } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { rightColor, leftColor } from '~/components/EditAndAddItem/common';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Memo, EAA_Select, EAA_Btn } from '~/components/EditAndAddItem';

const modeInfo = {
  add: {
    title: '風場合約新增',
  },
  edit: {
    title: '風場合約編輯',
  },
  view: {
    title: '風場合約檢視',
  },
};

const returnAryName = ({ ary = [], value = '' }) => {
  for (const o of ary) {
    if (o.value === value) return o.name;
  }
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }
  componentDidMount () {
    const { id, mode = '', setPageText, getWindManagementIdDetail, getWMGroupList } = this.props;
    getWMGroupList();
    setPageText(modeInfo[mode].title);
    if (mode !== 'add')getWindManagementIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { windManagementIdDetail: preWindManagementIdDetail = {} } = preProps;
    const { windManagementIdDetail = {}, mode } = this.props;
    if (Object.keys(preWindManagementIdDetail).length === 0 && Object.keys(windManagementIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: windManagementIdDetail, old_data: windManagementIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('WindManagementIdDetail');
    clearKey('PageText');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }) => {
    const { data: body } = this.state;
    const newBody = JSON.parse(JSON.stringify(body));
    newBody[label] = data;
    this.setState({ data: newBody });
  }

  getBody=() => {
    const { data } = this.state;
    const { WMGroupList = [] } = this.props;
    return ({
      group_name: data.group_name || '',
      order_num: parseInt(data.order_num),
      allocated_year: data.allocated_year || '',
      schedule_status: data.schedule_status || '0',
      windfield_fullname: `${returnAryName({ ary: WMGroupList, value: data.group_name }) || ''}_${data.windfield_name || ''}(民國${data.allocated_year || ''}年)`,
      windfield_name: data.windfield_name || '',
      windfield_note: data.windfield_note || '',
      windfield_simplename: `${data.windfield_name || ''}(民國${data.allocated_year || ''}年)`,
    });
  }

  add=() => {
    this.setState({ canSend: false });
    const body = this.getBody();
    this.props.postAddNewWindManagement(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    this.setState({ canSend: false });
    const { id, putWindManagementIdDetail } = this.props;
    const body = this.getBody();
    putWindManagementIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const returnselectValue = t => t || ' ';
    const errorAry = [
      returnInputValue(data.group_name) === '',
      returnInputValue(data.windfield_name) === '',
      returnInputValue(data.allocated_year) === '',
      typeof (data.order_num) !== 'number' && (!data.order_num.length || isNaN(data.order_num)),
      // returnInputValue(data.schedule_status) === '',
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { orgList = [], groupList = [], mode = '', WMGroupList = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const { schedule_status = '0' } = data;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text={modeInfo[mode].title} />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='群組' bol={true} haveChange={checkChange('group_name')} />
              <EAA_Select displayBorder disabled={disabled} list={WMGroupList} value={returnInputValue(data.group_name)} onChange={data => { this.changeData({ label: 'group_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText text='請選擇' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='排序值' bol={true} haveChange={checkChange('group_name')} />
              <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.order_num)} onChange={data => { this.changeData({ label: 'order_num', data }); }} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText text='請輸入數字' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='風場名稱' bol={true} haveChange={checkChange('windfield_name')} />
              <EAA_Input displayBorder disabled={disabled} hint='請輸入' value={returnInputValue(data.windfield_name)} onChange={data => { this.changeData({ label: 'windfield_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText text='請輸入' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='獲配年度' bol={true} haveChange={checkChange('allocated_year')} />
              <EAA_Input displayBorder disabled={disabled} label='民國' unit='年' type='number' hint='請輸入' value={returnInputValue(data.allocated_year)} onChange={data => { this.changeData({ label: 'allocated_year', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText text='請輸入' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='風場合約全稱' bol={false} />
              <EAA_Input displayBorder disabled hint='待輸入' value={`${returnAryName({ ary: WMGroupList, value: data.group_name }) || ''}_${data.windfield_name || ''}(民國${data.allocated_year || ''}年)`} />
            </EAA_ItemContainer>
            {/* {errorAry[4] && <EAA_ErrorText text='請選擇組織單位。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='風場合約簡稱' bol={false} />
              <EAA_Input displayBorder disabled hint='待輸入' value={`${data.windfield_name || ''}(民國${data.allocated_year || ''}年)`} />
            </EAA_ItemContainer>
            {/* {errorAry[5] && <EAA_ErrorText text='請選擇組織單位。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText text='工進填寫' bol haveChange={checkChange('schedule_status')} />
              <CircleCheckBox disabled={disabled} value={schedule_status === '1'} onClick={() => { this.changeData({ label: 'schedule_status', data: '1' }); }} />
              <div style={{ marginRight: 8 }}>月</div>
              <CircleCheckBox disabled={disabled} value={schedule_status === '2'} onClick={() => { this.changeData({ label: 'schedule_status', data: '2' }); }} />
              <div style={{ marginRight: 8 }}>月＋週</div>
              <CircleCheckBox disabled={disabled} value={schedule_status === '3'} onClick={() => { this.changeData({ label: 'schedule_status', data: '3' }); }} />
              <div style={{ marginRight: 8 }}>月＋週＋日</div>
              <CircleCheckBox disabled={disabled} value={schedule_status === '0'} onClick={() => { this.changeData({ label: 'schedule_status', data: '0' }); }} />
              <div>暫不顯示</div>
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText text='請勾選' />}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            <EAA_TitleText text='備註說明' haveChange={checkChange('windfield_note')} />
            <EAA_Memo displayBorder disabled={disabled} hint='請輸入' value={returnInputValue(data.windfield_note)} onChange={data => this.changeData({ label: 'windfield_note', data })} />
          </div>
        </EAA_Row>

        <div style={{ height: 16 }} />

        {data.add_time && (
          <EAA_Row>
            <EAA_ItemContainer>
              <EAA_TitleText text='創建時間' />
              <div>{data.add_time}</div>
            </EAA_ItemContainer>
          </EAA_Row>
        )}
        {data.upd_time && <div style={{ height: 12 }} />}
        {data.upd_time && (
          <EAA_Row>
            <EAA_ItemContainer>
              <EAA_TitleText text='上次更新時間' />
              <div>{data.upd_time}</div>
            </EAA_ItemContainer>
          </EAA_Row>
        )}

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewWindManagement' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutWindManagementIdDetail' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  windManagementIdDetail: state.data.WindManagementIdDetail,
  WMGroupList: state.data.WMGroupList,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setPageText: text => Actions.setPageText(dispatch, { text }),
  getWindManagementIdDetail: id => Actions_Wind.getWindManagementIdDetail(dispatch, { id }),
  getWMGroupList: () => Actions_Wind.getWMGroupList(dispatch),
  postAddNewWindManagement: body => Actions_Wind.postAddNewWindManagement(dispatch, { body }),
  putWindManagementIdDetail: (id, body) => Actions_Wind.putWindManagementIdDetail(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
